import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PlanSummary } from '../models/plan-summary';
import { Benefit } from '../models/benefit';
import { SelectionModel } from '@angular/cdk/collections';
import { Utils } from '../services/utils.service';

export interface PlanDetailsData {
    plan: PlanSummary;
    selections: SelectionModel<PlanSummary>;
}

@Component({
    selector: 'app-plan-details-modal',
    templateUrl: './plan-details-modal.component.html',
    styleUrls: ['./plan-details-modal.component.scss']
})
export class PlanDetailsModalComponent {

    dataSource: MatTableDataSource<Benefit>;
    displayedColumns = ['benefit', 'inValue', 'outValue'];

    constructor(
        public utils: Utils,
        private dialogRef: MatDialogRef<PlanDetailsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PlanDetailsData) {

        this.dataSource = new MatTableDataSource<Benefit>(this.data.plan.benefits);
    }

    onYesClick(): void {
        if (!this.data.selections.isSelected(this.data.plan)) {
            this.data.selections.toggle(this.data.plan);
        }
        this.dialogRef.close();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
